module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAClJREFUeNpiZGBg4IBibiDmhdIgPgj8AOKvQPwZSv9gYiARDAcNAAEGAAwtBRShb5+6AAAAAElFTkSuQmCC"


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/shared/shadow-lr.png
 ** module id = 527
 ** module chunks = 0
 **/